export enum PermissionType {
  OFFERS = 'OFFERS',
  PLAYERS = 'PLAYERS',
  MANAGEMENT_PAYMENTS = 'MANAGEMENT_PAYMENTS',
  CASINO = 'CASINO',
  JACKPOTS = 'JACKPOTS',
  LOTTO = 'LOTTO',
  SCRATCH = 'SCRATCH',
  BUNDLES = 'BUNDLES',
  APP = 'APP',
  EMAIL = 'EMAIL',
  WEBSITE = 'WEBSITE',
  MANUAL_ADJUSTMENT = 'MANUAL_ADJUSTMENT',
  MANUAL_DEPOSIT = 'MANUAL_DEPOSIT',
  GAMING = 'GAMING',
  SETTINGS_PAYMENTS = 'SETTINGS_PAYMENTS',
  COMPLIANCE = 'COMPLIANCE',
  DIAMONDS = 'DIAMONDS',
  LOCALE = 'LOCALE',
  SYSTEM = 'SYSTEM',
  DIAGNOSTICS = 'DIAGNOSTICS',
  TEAM = 'TEAM',
}

export class Permission {
  type: PermissionType;

  view?: boolean;

  modify?: boolean;

  export?: boolean;

  static MANAGE_PERMISSIONS = [
    PermissionType.PLAYERS,
    PermissionType.MANAGEMENT_PAYMENTS,
    PermissionType.CASINO,
    PermissionType.JACKPOTS,
    PermissionType.LOTTO,
    PermissionType.SCRATCH,
    PermissionType.BUNDLES,
    PermissionType.OFFERS,
    PermissionType.APP,
    PermissionType.EMAIL,
    PermissionType.WEBSITE,
  ];

  static SETTINGS_PERMISSIONS = [
    PermissionType.TEAM,
    PermissionType.SETTINGS_PAYMENTS,
    PermissionType.GAMING,
    PermissionType.COMPLIANCE,
    PermissionType.DIAMONDS,
    PermissionType.LOCALE,
    PermissionType.SYSTEM,
    PermissionType.DIAGNOSTICS,
  ];

  static ACTION_PERMISSIONS = [PermissionType.MANUAL_ADJUSTMENT, PermissionType.MANUAL_DEPOSIT];
}
